import { jsx, jsxs } from "react/jsx-runtime";
import { noop } from "@teselagen/ui";
import Caret from "./Caret";
import sector from "paths-js/sector";
import getRangeAngles from "./getRangeAnglesSpecial";
import PositionAnnotationOnCircle from "./PositionAnnotationOnCircle";
import React from "react";
import draggableClassnames from "../constants/draggableClassnames";
import { pureNoFunc } from "@teselagen/ui";
import {
  getSelectionMessage,
  preventDefaultStopPropagation
} from "../utils/editorUtils";
function SelectionLayer({
  isDraggable,
  selectionLayer,
  sequenceLength,
  radius,
  hideTitle,
  innerRadius,
  onRightClicked,
  onClick,
  index,
  isProtein,
  showAminoAcidUnitAsCodon
}) {
  const {
    color,
    start,
    end,
    hideCarets = false,
    style,
    className
  } = selectionLayer;
  const { startAngle, endAngle, totalAngle } = getRangeAngles(
    selectionLayer,
    sequenceLength
  );
  const section = sector({
    center: [0, 0],
    //the center is always 0,0 for our annotations :) we rotate later!
    r: innerRadius,
    R: radius,
    start: 0,
    end: totalAngle
  });
  const selectionMessage = getSelectionMessage({
    sequenceLength,
    selectionLayer,
    isProtein,
    showAminoAcidUnitAsCodon
  });
  const { transform } = PositionAnnotationOnCircle({
    sAngle: startAngle,
    eAngle: endAngle,
    height: 0
  });
  return /* @__PURE__ */ jsxs(
    "g",
    {
      onContextMenu: (event) => {
        onRightClicked && onRightClicked({
          annotation: selectionLayer,
          event
        });
      },
      onClick: onClick ? (event) => {
        onClick({
          annotation: selectionLayer,
          event
        });
      } : void 0,
      className: "veSelectionLayer " + (className || ""),
      children: [
        !hideTitle && /* @__PURE__ */ jsx("title", { children: selectionMessage }),
        /* @__PURE__ */ jsx(
          "path",
          {
            transform,
            className: "selectionLayer",
            style: { opacity: 0.3, ...style },
            d: section.path.print(),
            fill: color
          }
        ),
        !hideCarets && /* @__PURE__ */ jsx(
          Caret,
          {
            className: className + " selectionLayerCaret " + (isDraggable ? draggableClassnames.selectionStart : ""),
            isSelection: true,
            onClick: onClick ? noop : preventDefaultStopPropagation,
            selectionMessage,
            caretPosition: start,
            isProtein,
            sequenceLength,
            innerRadius,
            outerRadius: radius
          },
          "caret1"
        ),
        !hideCarets && /* @__PURE__ */ jsx(
          Caret,
          {
            className: className + " selectionLayerCaret " + (isDraggable ? draggableClassnames.selectionEnd : ""),
            isSelection: true,
            onClick: onClick ? noop : preventDefaultStopPropagation,
            selectionMessage,
            caretPosition: end + 1,
            isProtein,
            sequenceLength,
            innerRadius,
            outerRadius: radius
          },
          "caret2"
        )
      ]
    },
    "veSelectionLayer" + index
  );
}
export default pureNoFunc(SelectionLayer);
